import React, { Component } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import BulletPlot from "./BulletPlot";
import PropTypes from 'prop-types';

am4core.useTheme(am4themes_animated);

class DumbbellPlotDesil extends Component {
	static propTypes = {
		id: PropTypes.string.isRequired,
		dataset: PropTypes.array.isRequired,
	};
	componentDidUpdate(prevProps) {
		if (prevProps.dataset !== this.props.dataset) {
			this.componentDidMount(this.props.dataset);
		}
	}
	componentDidMount() {
		const { id, dataset } = this.props;

		var chart = am4core.create(id, am4charts.XYChart);

		// Transform data to include openValueX and valueX
		// chart.data = dataset
		chart.data = [
			{
				name: "SMP 1 Eduprime",
				start: 0.8,
				end: 3.1,
				children: [
					{ type: "line", color: "#000000", value: 0.8 },
					{ type: "cube-small", color: "#271E8A", value: 1.2 },
					{ type: "cube-big", color: "#03C46B", value: 1.5 },
					{ type: "cube-small", color: "#F97316", value: 1.9 },
					{ type: "3polygon", color: "#000000", value: 2.0 },
					{ type: "line", color: "#FF5757", value: 2.4 },
					{ type: "cube-small", color: "#015E56", value: 2.6 },
					{ type: "4polygon", color: "#F97316", value: 2.9 },
					{ type: "cube-small", color: "#D63D5D", value: 3.1 },
				],
			},
			{
				name: "SMP 1 Eduprime (Copy)",
				start: 1.0,
				end: 3.9,
				children: [
					{ type: "line", color: "#000000", value: 1.0 },
					{ type: "cube-small", color: "#271E8A", value: 1.5 },
					{ type: "cube-big", color: "#03C46B", value: 1.8 },
					{ type: "cube-small", color: "#F97316", value: 2.2 },
					{ type: "3polygon", color: "#000000", value: 2.5 },
					{ type: "line", color: "#FF5757", value: 2.9 },
					{ type: "cube-small", color: "#015E56", value: 3.1 },
					{ type: "4polygon", color: "#F97316", value: 3.4 },
					{ type: "cube-small", color: "#D63D5D", value: 3.6 },
					{ type: "cube-big", color: "#B71C37", value: 3.9 },
				],
			},
			{
				name: "SMP 2 Eduprime",
				start: 0.9,
				end: 3.7,
				children: [
					{ type: "line", color: "#000000", value: 0.9 },
					{ type: "cube-small", color: "#F97316", value: 1.3 },
					{ type: "3polygon", color: "#D63D5D", value: 1.7 },
					{ type: "cube-big", color: "#B71C37", value: 2.1 },
					{ type: "cube-small", color: "#03C46B", value: 2.5 },
					{ type: "cube-small", color: "#271E8A", value: 2.9 },
					{ type: "line", color: "#FF5757", value: 3.3 },
					{ type: "cube-big", color: "#015E56", value: 3.7 },
				],
			},
			{
				name: "SMP 3 Eduprime",
				start: 1.2,
				end: 3.6,
				children: [
					{ type: "cube-small", color: "#03C46B", value: 1.2 },
					{ type: "cube-small", color: "#F97316", value: 1.6 },
					{ type: "cube-big", color: "#B71C37", value: 2.0 },
					{ type: "cube-small", color: "#D63D5D", value: 2.4 },
					{ type: "line", color: "#000000", value: 2.8 },
					{ type: "cube-small", color: "#271E8A", value: 3.2 },
					{ type: "cube-big", color: "#03C46B", value: 3.6 },
				],
			},
			{
				name: "SMP 4 Eduprime",
				start: 1.1,
				end: 3.9,
				children: [
					{ type: "cube-big", color: "#271E8A", value: 1.1 },
					{ type: "cube-small", color: "#015E56", value: 1.4 },
					{ type: "line", color: "#F97316", value: 1.9 },
					{ type: "cube-small", color: "#03C46B", value: 2.2 },
					{ type: "3polygon", color: "#B71C37", value: 2.6 },
					{ type: "cube-big", color: "#03C46B", value: 2.9 },
					{ type: "cube-small", color: "#D63D5D", value: 3.4 },
					{ type: "line", color: "#000000", value: 3.9 },
				],
			},
			{
				name: "SMP 5 Eduprime",
				start: 1.0,
				end: 3.8,
				children: [
					{ type: "3polygon", color: "#000000", value: 1.0 },
					{ type: "cube-small", color: "#271E8A", value: 1.3 },
					{ type: "cube-big", color: "#F97316", value: 1.8 },
					{ type: "cube-small", color: "#03C46B", value: 2.3 },
					{ type: "line", color: "#B71C37", value: 2.7 },
					{ type: "cube-big", color: "#03C46B", value: 3.0 },
					{ type: "cube-small", color: "#271E8A", value: 3.5 },
					{ type: "line", color: "#015E56", value: 3.8 },
				],
			},
		];

		var categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
		categoryAxis.dataFields.category = "name";
		categoryAxis.renderer.grid.template.location = 0;
		categoryAxis.renderer.ticks.template.disabled = true;
		categoryAxis.renderer.minGridDistance = 15;
		categoryAxis.renderer.inversed = true;
		categoryAxis.renderer.grid.template.location = 0.5;

		categoryAxis.renderer.axisFills.template.disabled = false;
		categoryAxis.renderer.axisFills.template.fillOpacity = 1;
		categoryAxis.renderer.axisFills.template.adapter.add(
			"fill",
			function (fill, target) {
				if (target.dataItem.category === "SMP 2 Eduprime") {
					return am4core.color("#CAFCFB");
				}
				return am4core.color("#F9FAFB");
			}
		);

		var valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
		valueAxis.tooltip.disabled = true;
		valueAxis.renderer.ticks.template.disabled = true;
		valueAxis.renderer.axisFills.template.disabled = true;
		valueAxis.renderer.opposite = true;
		valueAxis.calculateTotals = true;
		valueAxis.renderer.labels.template.adapter.add("text", function (text) {
			return Number(text).toFixed(1);
		});

		var series = chart.series.push(new am4charts.ColumnSeries());
		series.strokeWidth = 1.5;
		series.stroke = am4core.color("black");
		series.dataFields.categoryY = "name";
		series.dataFields.openValueX = "start";
		series.dataFields.valueX = "end";

		// Bisa di custom sesuai kebutuhan
		series.tooltipText = "Start: {openValueX.value}\nEnd: {valueX.value}";

		series.sequencedInterpolation = true;
		series.fillOpacity = 0;
		series.strokeOpacity = 1;
		series.columns.template.height = 0.01;
		series.tooltip.pointerOrientation = "vertical";

		// Add middle bullets for data points
		chart.data.forEach((xData) => {
			for (let i = 0; i < xData.children.length; i++) {
				var xBull = series.bullets.push(new am4charts.Bullet());
				xBull.adapter.add("locationX", function (locationX, target) {
					if (xData.name === target.dataItem.categoryY) {
						let middle = target.dataItem.dataContext.children[i].value;
						let start = target.dataItem.openValueX;
						let end = target.dataItem.valueX;

						if (start === middle) {
							return 1;
						}
						if (end === middle) {
							return end;
						}
						return (middle - start) / (end - start);
					}
				});

				let image = xBull.createChild(am4core.Image);

				setImageProperties(image, xData.children[i]);
				image.horizontalCenter = "middle";
				image.verticalCenter = "middle";
			}
		});

		chart.cursor = new am4charts.XYCursor();
		chart.cursor.behavior = "zoomY";

		function setImageProperties(image, child) {
			switch (child.type) {
				case "cube-small":
					image.href = BulletPlot.rectangle({ color: child.color });
					image.width = 12;
					image.height = 12;
					break;

				case "cube-big":
					image.href = BulletPlot.rectangle({ color: child.color });
					image.width = 20;
					image.height = 20;
					break;

				case "line":
					image.href = BulletPlot.rectangle({ width: 8, color: child.color });
					image.width = 8;
					image.height = 20;
					break;

				case "3polygon":
					image.href = BulletPlot.polygon({ strokeColor: child.color });
					image.width = 20;
					image.height = 20;
					break;

				case "4polygon":
					image.href = BulletPlot.polygon({
						count: 4,
						strokeColor: child.color,
					});
					image.width = 20;
					image.height = 20;
					break;

				default:
					image.href = BulletPlot.rectangle({ color: "transparent" });
					image.width = 0;
					image.height = 0;
					break;
			}
		}

		// Uncomment ini untuk menampilkan scrollable axis x dan y
		// chart.scrollbarX = new am4core.Scrollbar();
		// chart.scrollbarY = new am4core.Scrollbar();
	}

	componentWillUnmount() {
		if (this.chart) {
			this.chart.dispose();
		}
	}

	render() {
		const { id } = this.props;
		return <div id={id} style={{ width: "100%", height: "400px" }}></div>;
	}
}

export default DumbbellPlotDesil;
